const localize = {};
localize['en'] = {
    SignInYourAccount: 'Sign in your account',
    TheFieldIsRequired: 'This field {0} is required.',
    EnterAValidEmail: 'Please eneter a valid email.',
    PasswordDoesNotMatch: '\'{0}\' and \'{1}\' does not match.',
    PleaseSelectOne: 'Please select one',
    TwoFactorProvider: 'Two Factor Provider',
    ChooseFile: 'Choose File',
    VerifiedSmsCodeSuccessfully: 'Verified SMS Code Successfully.',
    PreviewCroped: 'Preview Croped',
    PickUpImage: 'Pick Up Image',
    CropedImage: 'Croped Image',
    MakeSureAValidFileType: 'Make sure this is a valid {0} type{1}.'
};

localize['zh-CN'] = {
    SignInYourAccount: '登录你的账号',
    TheFieldIsRequired: '{0}是必填项.',
    EnterAValidEmail: '请输入一个有效的Email。',
    PasswordDoesNotMatch: '\'{0}\'和\'{1}\'不相匹配.',
    PleaseSelectOne: '请选择一个',
    TwoFactorProvider: '两步认证提供者',
    ChooseFile: '选择文件',
    VerifiedSmsCodeSuccessfully: 'SMS 码验证成功。',
    PreviewCroped: '预览裁剪图片',
    PickupImage: '选取图片',
    CropedImage: '新图片',
    MakeSureAValidFileType: '请选择一个有效的{0}{1}。'
};
localize['zh-Hans'] = {
    SignInYourAccount: '登录你的账号',
    TheFieldIsRequired: '{0}是必填项.',
    EnterAValidEmail: '请输入一个有效的Email。',
    PasswordDoesNotMatch: '\'{0}\'和\'{1}\'不相匹配.',
    PleaseSelectOne: '请选择一个',
    TwoFactorProvider: '两步认证提供者',
    ChooseFile: '选择文件',
    VerifiedSmsCodeSuccessfully: 'SMS 码验证成功。',
    PreviewCroped: '预览裁剪图片',
    PickupImage: '选取图片',
    CropedImage: '新图片',
    MakeSureAValidFileType: '请选择一个有效的{0}{1}。',
    Administration:'管理'
};
export default localize;
